module.exports = { 

  chatbannertxt: "ابدأ مراسلة الطبيب من هنا وسيقوم بالاتصال بك",
  writemsghere: "ابدأ استشارتك الآن",
  incomingcall: "مكالمة فيديو واردة",
  decline: "رفض",
  accept: "موافق",
  turn_on_camera: 'اضغط هنا لتفعيل الكاميرا',
  add_more_report: "إضافة المزيد من التقارير",
  optional: " (إختياري) ",
  uploadreport: "أضف تقرير",
  upload: "رفع",
  oops:"عذراً",
  looks_like_the_page:"يبدو أن الصفحة التي تحاول البحث عنها ليست موجودة. نأسف لذلك!",
  query: "اذا كانت لديك أي استفسارات أخرى",
  plzcntct: "الرجاء التواصل بنا على",
  am: "صباحاً",
  pm: "مساءً",
  waiting_note: "عزيزي العميل، الرجاء الانتظار في المحادثة، سيتصل بك الطبيب قريباً",
  };


// WEBPACK FOOTER //
// ./src/locales/ar.js